import React from 'react';

const About = (props) =>  {

  console.log(props.fn)
  return (
    <div className="about__wrapper">
     <h3>О нас</h3>
     <p>
{/* Мы видим свою задачу в том, чтобы помочь клиенту взглянуть на пространство иначе. <br />
Это всегда увлекательный процесс, как ребус/головоломка.<br />
Важно отображать взаимосвязь между архитектурой, интерьером и объектами. <br />
Плавный переход между этими понятиями, позволяет создать цельный продукт со своей историей (смыслом).

<br />
<br />
Подход, включающий в себя аспекты, с учетом контекста (история, легенда), традиций, в рамках которых чувства и физическое восприятие пространства, материалов, света интегрируются для человека в единую суть, в его образ.<br />
При создании истории проекта, мы полагаемся на интуицию. Такой сенсуальный способ помогает отобразить портрет клиента в интерьере объемами, цветом, наличием авторских предметов, искусства.</p>
      */}

Наша главная задача состоит в том, чтобы процесс создания интерьера был комфортным и увлекательным, а результат превосходил ожидания. 
<br />Мы, как профессионалы, видим потенциал пространства и помогаем максимально его использовать. <br />
Каждый проект - это история про человека, который будет в нем жить, и про функцию, которую этот интерьер будет выполнять. 
<br />
<br />
Каждый проект - это индивидуальная настройка важных деталей.<br />
<span onClick={() => props.fn('contacts')}>Для заявки на проект, свяжитесь с нами!</span>
      </p>
    </div>
  );
}

export default About;
